"use client";

import React, { createContext, useContext } from "react";
import { ResumeAnalysis } from "lib/resume-scoring/resume-analysis/resume-analyse-types";
import { Resume } from "lib/redux/types";

interface ScoreCheckContextType {
  handleAnalyseResume: () => void;
  calculateAndUpdateScore?: (analysisData: ResumeAnalysis, expLevel: "FRESHER" | "EXPERIENCED"
    // , currentResume: Resume
  ) => void;
}

const ScoreCheckContext = createContext<ScoreCheckContextType | undefined>(undefined);

export const useScoreCheck = () => {
  const context = useContext(ScoreCheckContext);
  if (!context) {
    throw new Error("useScoreCheck must be used within ScoreCheckProvider");
  }
  return context;
};

export const ScoreCheckProvider: React.FC<{
  children: React.ReactNode;
  handleAnalyseResume: () => void;
  calculateAndUpdateScore?: (analysisData: ResumeAnalysis, expLevel: "FRESHER" | "EXPERIENCED"
    // , currentResume: Resume
  ) => void;
}> = ({ children, handleAnalyseResume, calculateAndUpdateScore }) => {
  return (
    <ScoreCheckContext.Provider value={{ handleAnalyseResume, calculateAndUpdateScore }}>
      {children}
    </ScoreCheckContext.Provider>
  );
};
